import { Component, Prop, Vue } from 'vue-property-decorator';
import ClTypography from '../ClTypography/ClTypography.vue';

@Component({
  components: {
    ClTypography
  }
})
export default class ClFormControlLabel extends Vue {
  @Prop(Boolean)
  public disabled!: boolean;

  @Prop(String)
  public label!: string;

  public isControlLabel: boolean = true;

  @Prop({
    type: [String, Object, Number, Boolean],
    default: null
  })
  public value?: string | object | number | boolean;
}
